import { t } from "i18next";

const showDemoModal = (
  modalId: string,
  videoSrc: string,
  koMsg: string,
  enMsg: string
) => {
  if (document.getElementById(modalId)) return;

  const isKo = window.navigator.language.startsWith("ko");
  const overlay = document.createElement("div");
  overlay.id = modalId;
  overlay.style.cssText =
    "position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:99999;";

  overlay.innerHTML = `
    <div style="background:#fff;border-radius:12px;padding:24px 24px 20px;max-width:760px;width:92%;position:relative;box-shadow:0 8px 32px rgba(0,0,0,.2);">
      <button id="${modalId}-close" style="position:absolute;top:12px;right:14px;background:none;border:none;cursor:pointer;font-size:22px;color:#555;line-height:1;">&#10005;</button>
      <p style="margin:0 0 14px;font-size:15px;font-weight:600;color:#222;">${
        isKo ? koMsg : enMsg
      }</p>
      <video controls autoplay style="width:100%;border-radius:8px;display:block;background:#000;" src="${videoSrc}"></video>
    </div>`;

  document.body.appendChild(overlay);

  const close = () => {
    const el = document.getElementById(modalId);
    if (el) {
      const video = el.querySelector("video");
      if (video) {
        video.pause();
        video.src = "";
      }
      el.remove();
    }
  };
  document.getElementById(`${modalId}-close`)?.addEventListener("click", close);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener("keydown", function esc(e) {
    if (e.key === "Escape") {
      close();
      document.removeEventListener("keydown", esc);
    }
  });
};

export const showDemoDownloadModal = () =>
  showDemoModal(
    "demo-download-modal",
    "http://wrapsodyeco.kinsta.cloud/wp-content/uploads/2022/06/client_revision.mp4",
    t("common.noDemoVideo"),
    "This feature is not supported in the demo environment. Please refer to the video below for usage guidance."
  );

export const showDemoUploadModal = () =>
  showDemoModal(
    "demo-upload-modal",
    "http://wrapsodyeco.kinsta.cloud/wp-content/uploads/2022/06/file_upload.mp4",
    t("common.noDemoVideo"),
    "This feature is not supported in the demo environment. Please refer to the video below for usage guidance."
  );
